export default "__VITE_PUBLIC_ASSET__7c37745d__"